<template>
<div id="gyBox" ref="gyBox">
    <van-popup v-model="show" :style="{ padding: '2.5rem 0.8rem' }" closeable close-icon="cross" position="bottom" round>
        <div class="coverImg"> <img :src="showItem.cover" alt=""></div>
        <div class="coverName"> {{ showItem.name }}</div>
        <div class="gyText">
            <div class="gyTitle">公约企业</div>
            <div>
                <div class="gyImg"><img src="@/assets/img/Frame205@2x.png" alt=""></div>
                <div class="gyDesc">中国拍卖行业协会《中国文物艺术品拍卖企业自律公约》签约企业</div>
            </div>
        </div>
    </van-popup>
</div>
</template>

<script>
export default {
    name: "gyBox",
    props: {

    },
    data() {
        return {
            show: false,
            showItem: {
                cover: '',
                name: ''
            },
        }
    },
    methods: {
        showGY(e, item) {
            this.show = e
            this.showItem = item
        },

    }
}
</script>

<style lang="scss" scoped>
#gyBox {
    text-align: center;

    /deep/.van-popup {
        background: #F5F5F5;
    }

    .gyText {
        margin-top: 2rem;
        background: #fff;
        width: 100%;
        padding: 0.7rem;
        border-radius: 1rem;
        text-align: left;

        .gyTitle {
            font-weight: 600;
            font-size: 0.8rem;
            color: #000000;
            margin-bottom: 0.6rem;
        }

        .gyImg {
            display: inline-block;
            width: 3rem;
            vertical-align: top;
            img {
                height: 0.9rem;
                width: auto;
            }
        }

        .gyDesc {
            display: inline-block;
            width: calc(100% - 4rem);
            font-weight: 400;
            font-size: 0.6rem;
            color: #949596;
        }
    }

    .coverImg {
        width: 100%;

        overflow: hidden;

        img {
            width: 3rem;
            border-radius: 3rem;
        }

    }

    .coverName {
        margin-top: 0.8rem;
        font-weight: 600;
        font-size: 1rem;
        color: #000000
    }

}
</style>
